<template>
  <ValidationObserver ref="observerBooking">
    <b-card no-body class="mb-0">
      <div class="border-guests rounded p-1">

        <div class="d-flex justify-content-between clickable" @click="setShowGuest">
          <h6 class="mb-0">Lista de huéspedes</h6>
          <feather-icon :icon="showGuests ? 'ChevronUpIcon' : 'ChevronDownIcon'" />
        </div>

        <b-collapse id="guests-collapse" v-model="showGuests">

          <!-- ADULTOS -->
          <div v-if="guests.adults.length">
            <span class="font-weight-bold d-block mb-1">Adultos</span>

            <b-row
              v-for="(adult, index) in guests.adults"
              :key="adult.key"
              class="mb-2"
            >
              <b-col cols="12" md="3" v-if="isMain(adult, index)">
                <ValidationProvider :name="'Prefijo #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Prefijo'" :label-for="idFor(index,'prefix')" class="mb-1">
                    <b-form-select
                      size="sm"
                      :id="idFor(index,'prefix')"
                      v-model="adult.NamePrefix"
                      :state="errors.length ? false : null"
                    >
                      <option value="">Seleccione una opción</option>
                      <option v-for="(opt,i) in namesPrefix" :key="i" :value="opt.value">
                        {{ opt.text }}
                      </option>
                    </b-form-select>
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Nombre -->
              <b-col cols="12" md="3">
                <ValidationProvider :name="'Nombre #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Nombre'" :label-for="idFor(index,'name')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idFor(index,'name')"
                      placeholder="Nombre"
                      v-model="adult.GivenName"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <!-- Apellido -->
              <b-col cols="12" md="3">
                <ValidationProvider :name="'Apellido #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Apellido'" :label-for="idFor(index,'surname')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idFor(index,'surname')"
                      placeholder="Apellido"
                      v-model="adult.Surname"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3" v-if="adult.Adult">
                <ValidationProvider
                  :name="'Email #'+(index+1)"
                  :rules="isMain(adult,index) ? 'required|email' : 'email'"
                  v-slot="{ errors }"
                >
                  <b-form-group :label="'Email'" :label-for="idFor(index,'email')" class="mb-1">
                    <b-form-input
                      size="sm"
                      type="email"
                      :id="idFor(index,'email')"
                      placeholder="Email"
                      v-model="adult.Email"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3" v-if="isMain(adult,index)">
                <ValidationProvider :name="'Teléfono #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Teléfono'" :label-for="idFor(index,'phone')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idFor(index,'phone')"
                      placeholder="Teléfono"
                      v-model="adult.PhoneNumber"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3" v-if="isMain(adult,index)">                
                
                <ValidationProvider
                  name="País"              
                  v-slot="{ errors, valid, dirty, validate }"
                  rules="required"
                >
                  <b-form-group                    
                    :state="!errors.length ? (dirty ? true : null) : false"
                  >
                  <label for="">País</label>
                    <v-select
                      class="custom-v-select v-select-sm"                  
                      :options="countryOptions"     
                      label="label"
                      track-by="countryCode"
                      :reduce="opt => String(opt.value)"  
                      v-model="adult.country"
                      :class="{ 'is-invalid': errors.length, 'is-valid': valid && dirty }"
                      @option:selected="onCountrySelected(adult, $event)"                      
                      @search:blur="validate"
                      @blur.native="validate"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <input type="hidden" v-model="adult.countryCode">
              </b-col>

              <b-col cols="12" md="3" v-if="isMain(adult,index) && showInputNationality">
                <ValidationProvider :name="'Nacionalidad #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Nacionalidad'" :label-for="idFor(index,'nationality')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idFor(index,'nationality')"
                      placeholder="Nacionalidad"
                      v-model="adult.nacionality"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3" v-if="isMain(adult,index)">
                <ValidationProvider :name="'Ciudad #'+(index+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Ciudad'" :label-for="idFor(index,'city')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idFor(index,'city')"
                      placeholder="Ciudad"
                      v-model="adult.city"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
              
            </b-row>
          </div>

          <div v-if="guests.childs.length">
            <span class="font-weight-bold d-block mb-1">Niños</span>

            <b-row v-for="(child, idx) in guests.childs" :key="child.key" class="mb-2">
              <b-col cols="12" md="3">
                <ValidationProvider :name="'Nombre niño #'+(idx+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Nombre'" :label-for="idChildFor(idx,'name')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idChildFor(idx,'name')"
                      placeholder="Nombre"
                      v-model="child.GivenName"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3">
                <ValidationProvider :name="'Apellido niño #'+(idx+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Apellido'" :label-for="idChildFor(idx,'surname')" class="mb-1">
                    <b-form-input
                      size="sm"
                      :id="idChildFor(idx,'surname')"
                      placeholder="Apellido"
                      v-model="child.Surname"
                      :state="errors.length ? false : null"
                    />
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>

              <b-col cols="12" md="3">
                <ValidationProvider :name="'Edad niño #'+(idx+1)" rules="required" v-slot="{ errors }">
                  <b-form-group :label="'Edad'" :label-for="idChildFor(idx,'age')" class="mb-1">
                    <b-form-select
                      size="sm"
                      :id="idChildFor(idx,'age')"
                      v-model="child.Age"
                      :state="errors.length ? false : null"
                    >
                      <option v-for="(opt,i) in ageChildrenOptions" :key="i" :value="opt.value">{{ opt.text }}</option>
                    </b-form-select>
                    <b-form-invalid-feedback class="invalid-feedback-custom">{{ errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </b-col>
            </b-row>
          </div>

        </b-collapse>
      </div>
    </b-card>
  </ValidationObserver>
</template>

<script>
import { mapGetters, mapState  } from 'vuex'
import { namesPrefix, ageChildrenOptions } from '@/data/data'
import vSelect from "vue-select"

export default {
  props: {
    guests: { type: Object, required: true },
    showGuests: { type: Boolean, required: true, default: true }
  },
  components: {
    vSelect
  },
  mounted() {    
    (this.guests.adults || []).forEach(g => this.syncCountryCodeIfNeeded(g))
  },
  data () {
    return {
      namesPrefix,
      ageChildrenOptions
    }
  },
  computed: {
    ...mapGetters('appConfig', ['currentBreakPoint']),
    ...mapState('start',['countries','showInputNationality']),
    countryOptions() {
      return this.countries.map(c => ({
        label: c.displayES,
        value: String(c.name),
        countryCode : c.code,   
      }))
    },
  },
  methods: {
    setShowGuest () { this.$emit('set-show-guest', !this.showGuests) },
    isMain (adult, index) { return !!(adult && (adult.mainGuest || index === 0)) },
    idFor (idx, field) { return `adult-${idx}-${field}` },
    idChildFor (idx, field) { return `child-${idx}-${field}` },
    onCountrySelected(guest, opt) {
      guest.countryCode = opt?.countryCode ?? null
    },
    onCountryInput(guest, val) {
      if (val == null || val === '') guest.countryCode = null
    },
    syncCountryCodeIfNeeded(guest){
      if (guest?.country && !guest?.countryCode) {
        const found = this.countries.find(
          c => String(c.name) === String(guest.country)
        )
        guest.countryCode = found?.code  ?? null
      }
    },
  }
}
</script>

<style>
.border-guests{ border:1px solid #aaaaaa; margin-bottom:2.5rem; }
.invalid-feedback-custom{ font-size:75% !important; }
.v-select-sm .vs__dropdown-toggle {
  min-height: calc(1.80rem + 2px); /* mismo alto que b-form-input size="sm" */
  padding: 0.125rem 0.5rem;
  font-size: 0.80rem; /* tamaño de fuente del input sm */
}

.v-select-sm .vs__selected {
  font-size: 0.80rem;
}

.v-select-sm .vs__actions {
  padding-right: 0.25rem;
}

</style>
